import React from 'react';
import classNames from 'classnames';
const Spinner = ({ className, color, size }) => (<div className={classNames('loader', typeof color === 'string' ? `loader-${color}` : null, typeof size === 'string' ? `loader-${size}` : null, className)}/>);
export default Spinner;
